import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faChartSimple, faClone, faTriangleExclamation, faUser, faLock, faCircleInfo, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck, faClock, faCreditCard, faCircleDown, faCircleUp } from '@fortawesome/free-regular-svg-icons'
import { useUser } from "../utils/UserContext";
import { Link } from "react-router-dom";
import { GaugeComponent } from 'react-gauge-component';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';

function ImproveScore() {
    const { user } = useUser();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    const [notificationbar, setNotificationbar] = useState(false);
    const toggleNotification = () => {
        setNotificationbar(!notificationbar);
    };
    const [settingsBar, setSettingsBar] = useState(false);
    const toggleSettingsBar = () => {
        setSettingsBar(!settingsBar);
    };
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
        let isMounted = true;
        const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
        };
        fetchRate();
        return () => { isMounted = false; };
    }, [currencyCode]);
    const getCreditColor = (score) => {
      if (score >= 90) return { color: "#00FF15", label: "Excellent" };
      if (score >= 80) return { color: "#95ff87ff", label: "Very Good" };
      if (score >= 60) return { color: "#ffc107", label: "Good" };
      if (score >= 40) return { color: "#fd7e14", label: "Fair" };
      return { color: "#FF2121", label: "Poor" };
      };
    const creditInfo = getCreditColor(user?.credit_score || 0);

    return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Loan" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Loan" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="d-flex align-items-center justify-content-between my-3">
              <h5 className="mb-0 fw-bold">Improve Your Credit Score</h5>
              <Link to="/loan" className="myBtn rounded-pill px-3 py-2 fw-bold d-inline-block noLink" style={{fontSize:'13px'}}><FontAwesomeIcon icon={faArrowLeft} style={{fontSize: '12px'}} /> Back to Loan</Link>
            </div>
            <div className="row">
              <div className="col-lg-5">
                <div className="mycard">
                  <div className="d-flex align-items-start justify-content-between">
                    <div>
                      <p className="mb-2 fw-bold text-uppercase" style={{fontSize:'14px'}}>Current Score</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>Credit Score as at October 20, 2025</p>
                    </div>
                    <div className="myBtn px-2 py-1 fw-semibold lh-1 rounded-3" style={{fontSize:'12px'}}>Live</div>
                  </div>
                  <div className="position-relative mx-auto" style={{maxWidth:'400px',width:'100%'}}>
                    <GaugeComponent
                      type="semicircle"
                      minValue={300}
                      maxValue={850}
                      arc={{
                        colorArray: ['#FF2121', '#00FF15'],
                        padding: 0,
                        subArcs: [
                          { limit: 400 },
                          { limit: 500 },
                          { limit: 600 },
                          { limit: 700 },
                          { limit: 750 },
                          { limit: 800 },
                          { limit: 850 }
                        ]
                      }}
                      pointer={{ type: "blob", animationDelay: 1 }}
                      value={Number(user?.credit_score)}
                    />
                    <p className="mb-0 position-absolute fw-semibold text-uppercase fw-bold" style={{bottom:'10%',color: creditInfo.color, transform: 'translateX(-50%)',left:'50%'}}>{creditInfo.label}</p>
                  </div>
                  <p className="mb-0" style={{fontSize:'12px'}}>Projection (with actions below)</p>
                  <p className="mb-0 fw-bold" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faChartSimple} className="text-success me-1"/> +60–110 pts in 90–180 days</p>
                </div>
              </div>
              <div className="col-lg-7 mt-2">
                <div className="mycard">
                  <p className="mb-2 fw-bold text-uppercase" style={{fontSize:'14px'}}>HOW TO IMPROVE YOUR CREDIT SCORE</p>
                  <p className="mb-0" style={{fontSize:'14px'}}><b>A stronger credit score</b> helps you qualify for better rates, higher limits, and faster approvals. Follow these proven steps to build consistent, positive history.</p>
                  <div className="row">
                    <div className="col-md-4 col-lg-3 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                          <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '20px'}} className="text-success"/>
                        </div>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Pay bills on time</p>
                      </div>
                    </div>
                    <div className="col-md-4 col-lg-3 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                          <FontAwesomeIcon icon={faCircleDown} style={{fontSize: '20px'}} className="text-warning"/>
                        </div>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Keep credit utilization low</p>
                      </div>
                    </div>
                    <div className="col-md-4 col-lg-3 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                          <FontAwesomeIcon icon={faClock} style={{fontSize: '20px'}} className="text-info"/>
                        </div>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Don’t close old accounts</p>
                      </div>
                    </div>
                    <div className="col-md-4 col-lg-3 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                          <FontAwesomeIcon icon={faTriangleExclamation} style={{fontSize: '18px'}} className="text-danger"/>
                        </div>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Dispute credit report errors</p>
                      </div>
                    </div>
                    <div className="col-md-4 col-lg-3 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                          <FontAwesomeIcon icon={faUser} style={{fontSize: '18px'}} className="text-info"/>
                        </div>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Become an authorized user</p>
                      </div>
                    </div>
                    <div className="col-md-4 col-lg-3 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                          <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '18px'}} className="text-white"/>
                        </div>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Use secured credit cards</p>
                      </div>
                    </div>
                    <div className="col-md-4 col-lg-3 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                          <FontAwesomeIcon icon={faCircleUp} style={{fontSize: '20px'}} className="text-success"/>
                        </div>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Use credit builder loans</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="mycard mt-2">
                  <p className="mb-2 fw-bold text-uppercase" style={{fontSize:'14px'}}>Credit Factors</p>
                  <div className="row">
                    <div className="col-lg-4 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'60px',width:'60px'}}>
                          <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '20px'}} className="text-warning"/>
                        </div>
                        <div>
                          <p className="mb-0" style={{fontSize:'22px',lineHeight:'120%',fontWeight:'900'}}>24%</p>
                          <p className="mb-0 fw-bold text-prime" style={{fontSize:'14px',lineHeight:'115%'}}>Credit Card Utilization</p>
                          <p className="mb-0" style={{fontSize:'12px',lineHeight:'115%'}}>Lower is better — keep under 30%</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'60px',width:'60px'}}>
                          <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '25px'}} className="text-success"/>
                        </div>
                        <div>
                          <p className="mb-0" style={{fontSize:'22px',lineHeight:'120%',fontWeight:'900'}}>99%</p>
                          <p className="mb-0 fw-bold text-prime" style={{fontSize:'14px',lineHeight:'115%'}}>Payment History</p>
                          <p className="mb-0" style={{fontSize:'12px',lineHeight:'115%'}}>Timely payments build trust</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 g-3">
                      <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                        <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'60px',width:'60px'}}>
                          <FontAwesomeIcon icon={faClock} style={{fontSize: '25px'}} className="text-info"/>
                        </div>
                        <div>
                          <p className="mb-0" style={{fontSize:'22px',lineHeight:'120%',fontWeight:'900'}}>6Y 7M</p>
                          <p className="mb-0 fw-bold text-prime" style={{fontSize:'14px',lineHeight:'115%'}}>Age of Credit History</p>
                          <p className="mb-0" style={{fontSize:'12px',lineHeight:'115%'}}>Older accounts help your score</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="mycard mt-2">
                  <div className="d-flex align-items-center mb-4">
                    <FontAwesomeIcon icon={faTriangleExclamation} style={{fontSize: '16px'}} className="me-2 text-danger" />
                    <p className="mb-0 fw-bold">Top Negative Factors</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faCircleDown} style={{fontSize: '20px'}} className="text-danger"/>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">High credit utilization (65%)</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Suggestion: Pay down revolving balances below 30% utilization.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-danger fw-bold text-nowrap" style={{fontSize:'12px'}}>High impact</div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faCircleDown} style={{fontSize: '20px'}} className="text-danger"/>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">Recent late payment (60 days)</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Suggestion: Set up autopay/reminders; request goodwill adjustment if possible.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-danger fw-bold text-nowrap" style={{fontSize:'12px'}}>High impact</div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faCircleDown} style={{fontSize: '20px'}} className="text-warning"/>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">Short average account age (10 months)</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Suggestion: Keep oldest accounts open; avoid frequent new accounts.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-warning fw-bold text-black text-nowrap" style={{fontSize:'12px'}}>Medium impact</div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faCircleDown} style={{fontSize: '20px'}} className="text-warning"/>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">Multiple recent hard inquiries</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Suggestion: Limit new credit applications for 3–6 months.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-warning fw-bold text-black text-nowrap" style={{fontSize:'12px'}}>Medium impact</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="mycard mt-2">
                  <p className="mb-0 fw-bold mb-4">Quick Wins</p>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'40px',height:'40px',backgroundColor:'#ffc1071a'}}>
                        <FontAwesomeIcon icon={faCircleDown} style={{fontSize: '20px'}} className="text-warning"/>
                      </div>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">Reduce Utilization</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Target {"< 30%"} on cards; ideal {"< 10%"}.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-warning fw-bold text-black" style={{fontSize:'12px'}}>Make extra payment this cycle</div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'40px',height:'40px',backgroundColor:'#ffc1071a'}}>
                        <FontAwesomeIcon icon={faClock} style={{fontSize: '20px'}} className="text-warning"/>
                      </div>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">Set Autopay</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Avoid missed/late payments permanently.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-warning fw-bold text-black" style={{fontSize:'12px'}}>Enable autopay for minimum/full</div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'40px',height:'40px',backgroundColor:'#ffc1071a'}}>
                        <FontAwesomeIcon icon={faCircleUp} style={{fontSize: '20px'}} className="text-warning"/>
                      </div>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">Dispute Errors</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Incorrect late marks or balances.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-warning fw-bold text-black" style={{fontSize:'12px'}}>Open dispute with bureau</div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'40px',height:'40px',backgroundColor:'#ffc1071a'}}>
                        <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '20px'}} className="text-warning"/>
                      </div>
                      <div className="ms-3">
                        <p className="mb-0 fw-bold">Add On-Time History</p>
                        <p className="mb-0" style={{fontSize:'12px'}}>Use small subscriptions paid monthly.</p>
                      </div>
                    </div>
                    <div className="myBtn lh-1 px-2 py-1 rounded-4 bg-warning fw-bold text-black" style={{fontSize:'12px'}}>Route bills to card with autopay</div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="mycard mt-2 bg-prime text-white">
                  <p className="mb-0" style={{fontWeight:'900'}}>90–180 Day Roadmap</p>
                </div>
              </div>
              <div className="col-12">
                <div className="mycard mb-3">
                  <div className="row">
                    <div className="col-xxl-4 col-lg-6 g-4">
                      <div>
                        <p className="mb-2 fw-bold">This Week</p>
                        <ul style={{fontSize:'14px'}}>
                          <li>Pay down balance on Card •••• 4589 to {"< 30%"}</li>
                          <li>Enable autopay and payment reminders</li>
                          <li>Review reports for errors (all bureaus)</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xxl-4 col-lg-6 g-4">
                      <div>
                        <p className="mb-2 fw-bold">Next 60 Days</p>
                        <ul style={{fontSize:'14px'}}>
                          <li>Avoid new hard inquiries</li>
                          <li>Keep utilization {"< 10%"} for best impact</li>
                          <li>Make all payments on time</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xxl-4 col-lg-6 g-4">
                      <div>
                        <p className="mb-2 fw-bold">90–180 Days</p>
                        <ul style={{fontSize:'14px'}}>
                          <li>Consider credit limit increase (no new inquiry) after 3 on-time cycles</li>
                          <li>Diversify credit mix only if truly needed</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
    )
}

export default ImproveScore